import React, { useContext, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ResponsiveContext } from "../../contexts/ResponsiveContext.js";
import "./backtotop.scss";

const BackToTop = () => {
  const { phoneView } = useContext(ResponsiveContext);
  const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			const scrollTop = window.scrollY;
			const windowHeight = window.innerHeight;
			const docHeight = document.documentElement.scrollHeight;
	
			const footer = document.querySelector("footer");
			const footerHeight = footer ? footer.offsetHeight : 50;
	
			const isLongEnough = docHeight > windowHeight + footerHeight;
	
			if (isLongEnough) {
				const scrolledPercentage = scrollTop / (docHeight - windowHeight);
				setIsVisible(scrolledPercentage >= 0.4);
			} else {
				setIsVisible(false);
			}
		};
	
		window.addEventListener("scroll", handleScroll);
		window.addEventListener("resize", handleScroll);
	
		handleScroll();
	
		return () => {
			window.removeEventListener("scroll", handleScroll);
			window.removeEventListener("resize", handleScroll);
		};
	}, []);	

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {isVisible && phoneView && (
        <motion.div
          className="back-to-top-wrapper"
          onClick={handleScrollTop}
          title="Zum Anfang scrollen"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: [0, -5, 0] }}
          exit={{ 
						opacity: 0, 
						y: 50,
						transition: {
							duration: 0.8,
							ease: "easeOut"
						}
					}}
          transition={{
            duration: 0.6,
            ease: "easeOut",
            y: { repeat: Infinity, repeatType: "reverse", duration: 0.8, ease: "easeInOut" }, // Bounce
          }}
        >
          <i className="bi bi-arrow-up-circle"></i>
        </motion.div>
      )}
    </>
  );
};

export default BackToTop;
